module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// /~/axios/index.js
// module id = 143
// module chunks = 1